import { getRootPluaralTranslator } from '@utils/get-module-translator'

const __rootTc = getRootPluaralTranslator()

export function assetCiTitle(hasAssetModule, hasCmdbModule) {
  let text = ''
  if (hasAssetModule) {
    text = `${__rootTc('asset')}`
  }
  if (hasAssetModule && hasCmdbModule) {
    text = `${text}/`
  }
  if (hasCmdbModule) {
    text = `${text}${__rootTc('ci')}`
  }
  return text
}
